import NetZeroContainer from "./containers/NetZeroContainer";
import "./styles.scss";
export default NetZeroContainer;
